module.exports = __webpack_public_path__ + "media/images/athletes/3521-ba3e59924405fc7a36c0dc404a74e25a.png";